// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d260019924884f24f9a8","655":"4d2e3ba9b1b7e7e508f1"}[chunkId] + ".js";
};